import { Stack, TextInput } from "@mantine/core";
import { measurementUnitApi } from "apis";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { MeasurementUnitResponse } from "constants/types/measurement";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/MeasurementUnit/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import { editValidationSchema } from "./config";

type Props = {
  unit: MeasurementUnitResponse;
  onClose?: () => void;
  mutate?: () => void;
};

const EditForm: FC<Props> = ({ unit, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: unit.name ?? "",
    },
    validationSchema: editValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await measurementUnitApi.update(unit.id, { name: values.name });
        notification.success({ title: "Cập nhật đơn vị tính thành công" });
        onClose?.();
        mutate?.();
      } catch (error: ErrorStatusType | any) {
        notification.error({ title: "Cập nhật đơn vị tính thất bại", message: error?.error?.message });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <form id={FORM_IDS.EDIT} onSubmit={formik.handleSubmit}>
        <Stack gap="sm">
          <TextInput
            label="Mã đơn vị"
            value={unit.code}
            disabled
          />
          <TextInput
            label="Tên đơn vị tính"
            placeholder="Nhập tên đơn vị tính"
            id="name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && formik.errors.name}
            required
          />
        </Stack>
      </form>
    </Loading>
  );
};

export default EditForm;
